<template>

    <div class="modal__overlay">

        <div class="modal-activity" ref="modalRef">
            <div class="header">
                <!-- <h4>{{ props.content.id ? 'Editar ' : 'Crear '}} {{ props.content.type == 'FORUM' ? 'foro' : 'actividad para entregar'}}</h4> -->
                <h4>{{ title }}</h4>
                <i class="material-icons" @click.stop="emit('close')">close</i>
            </div>

            <div class="mandatory modal-activity__obligatoriedad">
                <!-- <h4>MARCAR COMO ACTIVIDAD OBLIGATORIA</h4> -->
                <h4>{{ $t('forumActivity.MARK_AS_MANDATORY_ACTIVITY') }}</h4>
                <div :class="{ active: setMandatory, disabled: props.status === 'A1' }" class="toggle-button" 
                    :style="props.status === 'A1' ? 'opacity:.35; cursor:default;' : ''" 
                    @click="props.status !== 'A1' && (setMandatory = !setMandatory)">
                    <div class="toggle-handle"></div>
                </div>

            </div>

            <div class="select-step">
                <!-- <span :class="{'--selected' : stepSelected == 'course'}" @click="stepSelected = 'course'">Pantalla del curso</span>
                <span :class="{'--selected' : stepSelected == 'activity'}" @click="stepSelected = 'activity'">Pantalla {{props.content.type.toUpperCase() == 'FORUM' ? 'del foro' : 'de la actividad'}}</span> -->
                <span :class="{'--selected' : stepSelected == 'course'}" @click="stepSelected = 'course'">{{ $t('forumActivity.COURSE_SCREEN') }}</span>
                <span :class="{'--selected' : stepSelected == 'activity'}" @click="stepSelected = 'activity'">{{ activityScreenLabel }}</span>
            </div>
            
            <div v-show="stepSelected == 'course'" class="content-container">
                <!-- <h4>ENUNCIADO</h4> -->
                <h4>{{ $t('forumActivity.STATEMENT') }}</h4>
                <div>
                    <TinyMCE 
                        :content="preview.enunciado"
                        ref="tinyEditorPreview"
                        :id="'activity-preview'"
                    />
                </div>

                <div class="pedagogical">
                    <!-- <h4>CONTENIDO PEDAGÓGICO</h4> -->
                    <h4>{{ $t('forumActivity.PEDAGOGICAL_CONTENT') }}</h4>
                    <div :class="{ active: preview.configPedagogical.show }" class="toggle-button" @click="preview.configPedagogical.show = !preview.configPedagogical.show">
                        <div class="toggle-handle"></div>
                    </div>
                </div>

                <template v-if="preview.configPedagogical.show">
                    <div class="select">
                        <Select 
                            v-model="preview.configPedagogical.type"
                            mode="simple"
                            id="selectPedagogicalTypePreview"
                            :label="$t('forumActivity.CONTENT_TYPE')"
                            valueProp="id"
                            valueLabel="name"
                            :values="preview.configPedagogical.types"
                            :isDropdown="true"
                        />
                    </div>
                    <Input 
                        @update:modelValue="validate()"
                        :isError="required.fields.includes('geniallyPreview')"
                        :errorMessage="$t('forumActivity.REQUIRED_FIELD')"
                        type="text"
                        id="geniallyURL"
                        :placeholder="$t('forumActivity.LINK')"
                        v-model="preview.geniallyURL"
                        :label="$t('forumActivity.LINK')"
                    />

                </template>
            </div>

            <div v-show="stepSelected == 'activity'" class="content-container">
                <!-- <h4>ENUNCIADO</h4> -->
                <h4>{{ $t('forumActivity.STATEMENT') }}</h4>
                <div>
                    <TinyMCE 
                        :content="activityView.enunciado"
                        ref="tinyEditorActivityView"
                        :id="'activity-dataview'"
                    />
                </div>

                <div class="pedagogical">
                    <!-- <h4>CONTENIDO PEDAGÓGICO</h4> -->
                    <h4>{{ $t('forumActivity.PEDAGOGICAL_CONTENT') }}</h4>
                    <div :class="{ active: activityView.configPedagogical.show }" class="toggle-button" @click="activityView.configPedagogical.show = !activityView.configPedagogical.show">
                        <div class="toggle-handle"></div>
                    </div>
                </div>

                <template v-if="activityView.configPedagogical.show">
                    <div class="select">
                        <Select 
                            v-model="activityView.configPedagogical.type"
                            mode="simple"
                            id="selectPedagogicalTypeactivityView"
                            label="Tipo de contenido"
                            valueProp="id"
                            valueLabel="name"
                            :values="activityView.configPedagogical.types"
                            :isDropdown="true"
                        />
                    </div>
                    <Input 
                        :isError="required.fields.includes('geniallyActivityView')" 
                        errorMessage="Campo requerido" 
                        type="text" 
                        id="geniallyURL" 
                        :placeholder="'Link'" 
                        v-model="activityView.geniallyURL" label="Link"
                        @update:modelValue="validate()"
                    />
                </template>
            </div>

            <div class="modal__buttons">
                <button class="cancel" @click.stop="emit('close')" :disabled="saving">{{ $t('global.CANCEL') }}</button>
                <button class="confirm" @click.stop="save()" :disabled="saving">
                    {{ stepSelected == 'course' ? $t('global.CONTINUE') : $t('global.SAVE') }}
                    <i class="material-icons">arrow_forward</i>
                </button>
            </div>

        </div>


    </div>

</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Select from '@/components/Inputs/Select.vue';
import Input from '@/components/Input.vue';
import TinyMCE from '@/components/TinyMCE.vue';
import defaultContents from "./defaultContents.js";
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';


const store = useStore();
const route = useRoute();

const { t } = useI18n();


const props = defineProps({
    content: Object,
    status: String
});
const emit = defineEmits(['close','reload']);

const modalRef = ref(null);
const setMandatory = ref(false);
const setMandatoryDisabled = ref(false);
const stepSelected = ref('course');
const saving = ref(false);

const tinyEditorPreview = ref(null);
const tinyEditorActivityView = ref(null);

const enunciadoTemplate = defaultContents.find(cont => cont.id == props.content.type).content;

// ---------------------------------------------------------------------

const title = computed(() => {
  const action = props.content.id ? t('forumActivity.EDIT') : t('forumActivity.CREATE');
  const contentType = props.content.type === 'FORUM' ? t('forumActivity.FORUM') : t('forumActivity.ACTIVITY_TO_DELIVER');
  return `${action} ${contentType}`;
});

const activityScreenLabel = computed(() => {
  const typeLabel = props.content.type.toUpperCase() === 'FORUM' ? t('forumActivity.FORUM') : t('forumActivity.ACTIVITY');
  return t('forumActivity.ACTIVITY_SCREEN', { type: typeLabel });
});



const obtainContent = (tag, text) => {
    let open = `[BEGIN_${tag}]`;
    let close = `[END_${tag}]`;
    let begin = text.indexOf(open) + open.length;
    let end = text.indexOf(close);

    if (begin !== -1 && end !== -1) {
        return text.substring(begin, end);
    } else {
        return null; // La etiqueta no fue encontrada
    }
}

const obtainGeniallyURL = (html) => { 
    if(!html) return ''
    let $div = document.createElement('div');
    $div.innerHTML = html;
    let $iframe = $div.querySelector('iframe');
    let $src = $iframe.getAttribute('src');
    $div.remove();
    return $src;
}

const preview = ref({
    enunciado: obtainContent('ENUNCIADO', props.content.data.Preview) || (props.content.id ? '' : enunciadoTemplate),
    geniallyURL: obtainGeniallyURL( obtainContent('GENIALLY', props.content.data.Preview) ) || '',
    configPedagogical: {
        show: true,
        type: "genially",
        types: [
            { id: "genially", name: "Genially", },
        ]
    }
})

const activityView = ref({
    enunciado: obtainContent('ENUNCIADO', props.content.data.Data) || '',
    geniallyURL: obtainGeniallyURL( obtainContent('GENIALLY', props.content.data.Data) ) || '',
    configPedagogical: {
        show: true,
        type: "genially",
        types: [
            { id: "genially", name: "Genially", },
        ]
    }
})


const savePreview = ()=> {
    let enunciado = `[BEGIN_ENUNCIADO]${tinyEditorPreview.value.editorInstance.getContent()}[END_ENUNCIADO]`;
    let genially = 
        preview.value.configPedagogical.show
            ? `[BEGIN_GENIALLY]<div style="width: 100%;"><iframe style="width: 100%;" frameborder="0" width="1200" height="675" allowfullscreen="allowfullscreen" src="${preview.value.geniallyURL}"></iframe></div>[END_GENIALLY]`
            : '';
    let button = `[BEGIN_BOTON]<div style="font-family:'Open Sans',sans-serif; margin-top:12px;"><a href="" style="width:fit-content; padding:12px 40px; display:flex; align-items:center; justify-content:center; gap:4px; border-radius:30px; font-size:16px; font-weight:400; background-color:#009696; color:#fff; text-decoration:none;">Ir ${props.content.type == 'ATTACH' ? 'a la actividad' : 'al foro'}<i class="material-icons" style="font-size:16px;">arrow_forward</i></a></div>[END_BOTON]`;
    let newPreview = enunciado+genially+button;
    return newPreview;
}

const saveActivityView = ()=> {
    let enunciado = `[BEGIN_ENUNCIADO]${tinyEditorActivityView.value.editorInstance.getContent()}[END_ENUNCIADO]`;
    let genially = 
        activityView.value.configPedagogical.show
            ? `[BEGIN_GENIALLY]<div style="width: 100%;"><iframe style="width: 100%;" frameborder="0" width="1200" height="675" allowfullscreen="allowfullscreen" src="${activityView.value.geniallyURL}"></iframe></div>[END_GENIALLY]`
            : '';
    let newActivityView = enunciado+genially;
    return newActivityView;
}

// -----------------------------------------------------------
const required = ref({
    hasError: false,
    fields: []
})

const validate = () => {
    required.value.hasError = false;
    required.value.fields = [];
    if(preview.value.configPedagogical.show && !preview.value.geniallyURL){
        required.value.fields.push('geniallyPreview')
        required.value.hasError = true;
    }
    if(activityView.value.configPedagogical.show && !activityView.value.geniallyURL){
        required.value.fields.push('geniallyActivityView')
        required.value.hasError = true;
    }
}


const save = async ()=> {
    validate()
    if(stepSelected.value == 'course'){
        if(!required.value.fields.includes('geniallyPreview')){
            stepSelected.value = 'activity';
            modalRef.value.scrollTop = 0;
            return;
        }
    }
    if(required.value.hasError) return;
    saving.value = true;
    let model = props.content;
    model.isMandatory = setMandatory.value;
    model.data = {
        Preview: savePreview(),
        Data: saveActivityView()
    }
    try {
        model.id
            ? await store.dispatch('contentEditor_editContent', model)
            : await store.dispatch('contentEditor_createContent', model);
        emit('reload');
        console.log(model);
    } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', { text: t('forumActivity.ERROR_SAVING_CONTENT') });
    } finally {
        saving.value = false;
    }
}

onMounted(()=>{
    setMandatory.value = props.content.isMandatory;
    setMandatoryDisabled.value = props.content.type == 'ATTACH' && route.query.type;
})

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import './commonStyles.scss';

.modal-activity{
    @include componentModal;
    display: flex;
    flex-direction: column;
    gap: 22px;
    .header{
        padding-bottom: 6px;
        display: flex;
        justify-content: space-between;
        i{
            cursor: pointer;
        }
    }
    h4{
        padding-left: 4px;
    }
    .select-step{
        display: flex;
        align-items: center;
        gap: 22px;
        span{
            font-size: 14px;
            font-weight: 600;
            padding: 8px 24px 8px 8px;
            margin: 0 6px;
            cursor: pointer;
            &.--selected{
                color: $green;
                border-bottom: 3px solid $green;
            }
        }
    }
    .content-container{
        display: flex;
        flex-direction: column;
        gap: 22px;
    }
    .select{
        max-width: 240px;
    }
    .pedagogical, .mandatory{
        display: flex;
        justify-content: space-between;
    }
}



</style>